var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-segments" }, [
    _c(
      "div",
      { staticClass: "d-flex", staticStyle: { "background-color": "#ffffff" } },
      [
        _c("a-card", { staticClass: "vh-100 w-100" }, [
          _c(
            "div",
            {
              staticClass:
                "row m-3 d-flex flex-row align-items-center justify-content-around",
              staticStyle: { width: "48%" },
            },
            [
              _c("h3", { staticClass: "col-md mt-2 segment-main-title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.userSegments"))),
              ]),
              _vm._v(" "),
              _vm.checkPermission(
                _vm.PERMISSION_TYPES["chatbot.usersegments.create"].tr.name
              )
                ? _c(
                    "a-button",
                    {
                      staticClass:
                        "col-md d-flex flex-row align-items-center segment-main-title",
                      attrs: { type: "primary", size: "large" },
                      on: {
                        click: function ($event) {
                          _vm.modalVisible = true
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons m-0 p-0" }, [
                        _vm._v(" add "),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.addSegment")) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                { staticClass: "m-5" },
                [
                  _c(
                    "a-table",
                    {
                      key: "vtable-" + _vm.renderCount,
                      attrs: {
                        rowKey: "_id",
                        columns: _vm.columns,
                        dataSource: _vm.segments,
                        pagination: false,
                        customRow: function (record) {
                          return {
                            props: {},
                            on: {
                              mouseover: function (event) {
                                _vm.rowMouseOver(record)
                              },
                              mouseleave: function (event) {
                                _vm.rowMouseLeave(record)
                              }, // mouse leave row
                            },
                          }
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "avatar",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-segment-avatar text-center",
                                    class: {
                                      "user-segment-avatar-odd":
                                        _vm.isRowNumberOdd(record),
                                    },
                                  },
                                  [
                                    _c(
                                      "md-highlight-text",
                                      {
                                        staticClass: "text-center",
                                        attrs: { "md-term": "term" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              record.name
                                                .slice(0, 2)
                                                .toUpperCase()
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "users",
                            fn: function (text, record) {
                              return _c("span", {}, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      !!record.users.length
                                        ? record.users.length + " User"
                                        : _vm.$t("chatbotv2.noUsersAdded")
                                    )
                                ),
                              ])
                            },
                          },
                          {
                            key: "operation",
                            fn: function (text, record) {
                              return _vm.checkPermission(
                                _vm.PERMISSION_TYPES[
                                  "chatbot.usersegments.update"
                                ].tr.name
                              )
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-flex flex-row justify-content-end operation-buttons",
                                      class: {
                                        hidden:
                                          _vm.selectedRowId !== record._id,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "material-icons mx-2 text-primary operation-button",
                                          on: {
                                            click: function () {
                                              return _vm.onEditSegment(record)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            edit\n                        "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.checkPermission(
                                        _vm.PERMISSION_TYPES[
                                          "chatbot.usersegments.delete"
                                        ].tr.name
                                      )
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons mx-2 text-danger operation-button",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showConfirm(record)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            delete\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e()
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          attrs: { slot: "segmentNameTitle" },
                          slot: "segmentNameTitle",
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("chatbotv2.segmentName")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { attrs: { slot: "usersTitle" }, slot: "usersTitle" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("chatbotv2.usersInSegment"))
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _c("div", [_c("a-spin")], 1),
        ]),
        _vm._v(" "),
        _c(
          "a-modal",
          {
            attrs: {
              id: "add-segment-modal",
              title: _vm.editMode
                ? _vm.$t("chatbotv2.updateSegment")
                : _vm.$t("chatbotv2.newSegment"),
              wrapClassName: "vertical-center-modal",
              okText: !_vm.editMode
                ? _vm.$t("message.ok")
                : _vm.$t("message.edit"),
              cancelText: _vm.$t("message.cancel"),
            },
            on: {
              ok: function ($event) {
                return _vm.modalOk()
              },
              cancel: function ($event) {
                return _vm.modalCancel()
              },
            },
            model: {
              value: _vm.modalVisible,
              callback: function ($$v) {
                _vm.modalVisible = $$v
              },
              expression: "modalVisible",
            },
          },
          [
            _c(
              "a-form",
              {
                staticClass: "d-flex flex-column justify-content-center",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.handleSave.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      label: _vm.$t("chatbotv2.segmentName"),
                      fieldDecoratorOptions: {
                        rules: [
                          {
                            required: true,
                            message: "Please input name of segment",
                          },
                        ],
                      },
                    },
                  },
                  [
                    _c("a-input", {
                      model: {
                        value: _vm.segment.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.segment, "name", $$v)
                        },
                        expression: "segment.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }